import { OnInit, Component, Optional, Inject} from '@angular/core';

@Component({
    selector: 'Income-CashWrapper',
    templateUrl: './IncomeCashWrapper.component.html',
    styleUrls: ['./Wrapper.component.css']
})
export class IncomeCashFWrapper implements OnInit {
    isAdaTheme: boolean = false;
    title: string;
    constructor(
        @Optional() @Inject('AppSettings') appSettings: any) {
        if (appSettings.themeType && appSettings.themeType === 'ada') {
        this.isAdaTheme = true;
        this.title = 'IncomeCashWrapper';
    }}
    ngOnInit() {}
}
